import axios from "axios";

// Blog / SEO pages API (separate backend from the casino API).
// If the coin project uses a different endpoint, change this one line.
export const NEVTAN_PAGES_BASE_URL = "https://seo-api.nevtan.com/api/public/spinsaga";
export const NEVTAN_PAGES_PRODUCT = "spinsaga_coin";

const client = axios.create({
  baseURL: NEVTAN_PAGES_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const getPages = async (language) => {
  const params = { product: NEVTAN_PAGES_PRODUCT };
  if (language) params.language = language;
  const res = await client.get("pages", { params });
  return res.data;
};

export const getPage = async (slug) => {
  const res = await client.get(`pages/${slug}`);
  return res.data;
};

export const acknowledgePage = async (slug) => {
  const res = await client.post(`pages/${slug}/acknowledge`);
  return res.data;
};
